<template>
  <div class="footer">
    <div class="footer-top">
      <div class="contact-us">
        <div style="color: #FFFFFF;font-size: 0.25rem"><img style="width: 1rem" src="../../assets/image/index/logo.png"></div>
        <div
          style="font-size: 0.16rem;font-family: PingFang SC;font-weight: 500;line-height: 0.22rem;color: #FFFFFF;margin-top: 0.37rem">
          联系我们
        </div>
        <div style="display: flex">
          <div style="margin-right: 0.4rem">
            <div
              style="font-size: 0.12rem;font-family: PingFang SC;font-weight: 400;line-height: 0.17rem;color: #FFFFFF;opacity: 0.8;margin-top: 0.19rem">
              <img class="footer-icon" src="../../assets/image/footer-tel.png">商务合作
            </div>
            <div
              style="font-size: 0.18rem;font-family: DIN Alternate;font-weight: bold;line-height: 0.21rem;color: #FFFFFF;opacity: 1;margin-top: 0.09rem">
              <a class="tel" href="tel:18617131848">18617131848</a>
            </div>
          </div>
          <div>
            <div
              style="font-size: 0.12rem;font-family: PingFang SC;font-weight: 400;line-height: 0.17rem;color: #FFFFFF;opacity: 0.8;margin-top: 0.19rem">
              <img class="footer-icon" src="../../assets/image/footer-tel.png">网络问题
            </div>
            <div
              style="font-size: 0.18rem;font-family: DIN Alternate;font-weight: bold;line-height: 0.21rem;color: #FFFFFF;opacity: 1;margin-top: 0.09rem">
              <a class="tel" href="tel:400-666-5780">400-666-5780</a>
            </div>
          </div>
        </div>

        <div
          style="font-size: 0.12rem;font-family: PingFang SC;font-weight: 400;line-height: 0.17rem;color: #FFFFFF;opacity: 0.8;margin-top: 0.37rem">
          <img class="footer-icon" src="../../assets/image/footer-email.png">电子邮箱
        </div>
        <div
          style="font-size: 0.18rem;font-family: DIN Alternate;font-weight: bold;line-height: 0.21rem;color: #FFFFFF;opacity: 1;margin-top: 0.08rem">
          info@magicwifi.com.cn
        </div>
        <div
          style="font-size: 0.12rem;font-family: PingFang SC;font-weight: 400;line-height: 0.17rem;color: #FFFFFF;opacity: 0.8;margin-top: 0.2rem">
          <img class="footer-icon" src="../../assets/image/footer-address.png">地址：深圳市南山区科技园南长虹科技大厦2105
        </div>
      </div>
      <div class="footer-item-list">
        <div class="footer-item">
          <div  class="footer-item-title">关于我们</div>
          <div @click="jump('about')" class="footer-item-con">公司介绍</div>
          <div @click="jump('contact')" class="footer-item-con">联系我们</div>
          <div @click="jump('talent')" class="footer-item-con">人才招聘</div>
        </div>
        <div class="footer-item">
          <router-link to="/solution"><div class="footer-item-title">解决方案</div></router-link>
          <router-link to="/solution"><div class="footer-item-con">高校无线网络</div></router-link>
          <router-link to="/solution"><div class="footer-item-con">中职无线网络</div></router-link>
          <router-link to="/solution"><div class="footer-item-con">工厂无线网络</div></router-link>
          <router-link to="/solution"><div class="footer-item-con">工地无线网络</div></router-link>
          <router-link to="/solution"><div class="footer-item-con">校园一脸通</div></router-link>
        </div>
        <div class="footer-item">
          <div class="footer-item-title">产品中心</div>
          <router-link to="/productDetail?id=1"> <div  class="footer-item-con">网关</div></router-link>
          <router-link to="/productDetail?id=2"> <div class="footer-item-con">交换机</div></router-link>
          <router-link to="/productDetail?id=3"><div class="footer-item-con">AP</div></router-link>
          <router-link to="/productDetailSoft?id=8"><div class="footer-item-con">认证计费系统</div></router-link>
          <router-link to="/productDetailSoft?id=9"><div class="footer-item-con">网管系统</div></router-link>
        </div>
        <div class="footer-item" style="margin-left: -0.4rem">
          <div class="footer-item-title" style="visibility: hidden">产品中心</div>
          <router-link to="/productDetailSoft?id=11"><div class="footer-item-con">运维工单</div></router-link>
          <router-link to="/productDetailSoft?id=27"><div class="footer-item-con">客服系统</div></router-link>
          <router-link to="/productDetailSoft?id=28"><div class="footer-item-con">审计系统</div></router-link>
          <router-link to="/productDetailSoft?id=14"><div class="footer-item-con">上网管控</div></router-link>
          <router-link to="/productDetailSoft?id=10"><div class="footer-item-con">运营中台</div></router-link>

        </div>
        <div class="footer-item">
          <div  class="footer-item-title">新闻动态</div>
          <div @click="jump('news',{type:1})" class="footer-item-con">展会风采</div>
          <div @click="jump('news',{type:2})"  class="footer-item-con">项目拓展</div>
          <div @click="jump('news',{type:3})" class="footer-item-con">lemon动态</div>
          <div @click="jump('news',{type:4})" class="footer-item-con">其他</div>
        </div>
      </div>
      <div class="footer-item-public">
        <img v-if="imgFlag==0"  class="footer-item-public-img" src="@/assets/image/index/wx-public.jpg">
        <img v-else class="footer-item-public-img" :src="img">
        <div id="wl-qrcode3"></div>
        <div class="footer-item-public-text">扫码联系我们</div>
      </div>
    </div>
    <div style="margin-top: 0.63rem;border-top:0.01rem solid #666666;height: 0.01rem;width: 100%;"></div>
    <div class="footer-ba" style="display: flex;align-items: center;justify-content: center;">
      <div>Copyright © 2005-2024 lemonwifi.cn 深圳市网联天下科技有限公司版权所有</div>
      <img src="../../assets/image/beian.png" style="width: 0.13rem;height: 0.14rem;margin: 0 0.05rem">
      <div>备案号：粤ICP备 14021249号</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data(){
    return{
      imgFlag:0,
      img:'',
    }
  },
  mounted() {

    this.initializeAndRun();
  },
  methods:{
    jump(url,query){
      if(url==='news'){
        this.$router.push({
          name: url,
          query
        });
      }else if(url==='product'){

      }else {
        this.$router.push({
          name: url,
        });
      }
    }  ,
    loadScript(src, id) {
      return new Promise((resolve, reject) => {
        if (document.getElementById(id)) {
          resolve(); // 如果脚本已经存在，直接resolve
          return;
        }

        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.id = id;

        script.onload = () => {
          resolve(); // 脚本加载成功，resolve
        };

        script.onerror = () => {
          reject(new Error(`Script load error for ${src}`)); // 脚本加载失败，reject
        };

        let s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
      });
    },
    async initializeAndRun() {
      try {
        await this.loadScript(
          'https://material.weiling.cn/h5/willing-third-party-js/v1/qrcode-custom-comp-v1.min.js',
          'wlQRCS'
        );

        // 等待脚本加载完成后初始化
        wlQrcodeCustomComp.init({
          wl_id: 'wpW2WmDAAAsuSkpyHYrwjV4tnMu-Zjag', // [修改1：将wl_id粘贴至此]
        });

        // 初始化完成后要执行的代码
        console.log('wlQrcodeCustomComp initialized footer');
        // 在这里添加你需要执行的代码
        this.getCode();
      } catch (error) {
        console.error(error); // 处理加载脚本时的错误
      }
    },
    getCode(){
      wlQrcodeCustomComp.getQrCodeUrl(
        {
          wl_qrcode_id: "1801157726622015488", //  [修改1：将wl_qrcode_id粘贴至此]
        },
        (data) => {
          console.log(data); // data中包含二维码图片地址
          if(data.code==200){
            this.imgFlag=1;
            this.img=data.data.qr_code;
          }
        }
      );
    }
  }

}
</script>

<style scoped>
.footer {
  background: #333333;
  padding: 1rem 1.8rem 1.75rem 1.8rem;
}
.footer-icon{
  width: 0.1rem;
  height: 0.1rem;
  margin-right: 0.04rem;
}
.footer-top{
  display: flex;
  justify-content: space-between;
}

.contact-us {
  padding-right: 1.2rem;
  padding-bottom: 0.25rem;
  border-right: 0.01rem solid #666666;;
}
.footer-item-list{
  display: flex;
  justify-content: space-between;
  padding:0.25rem 2.2rem 0 1.2rem;
  flex: 1;
}
.footer-item{
}

.footer-item-title {
  font-size: 0.16rem;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 0.22rem;
  color: #FFFFFF;
  opacity: 1;
}

.footer-item-con {
  margin-top: 0.22rem;
  font-size: 0.14rem;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 0.2rem;
  color: #FFFFFF;
  opacity: 0.8;
  cursor: pointer;
}
.footer-item-public{
  padding-top: 0.25rem;
  display: flex;
  /*justify-content: center;*/
  align-items: center;
  flex-direction: column;
}

.footer-item-public-img {
  width: 1.2rem;
  height: 1.2rem;
  margin-bottom: 0.11rem;
}

.footer-item-public-text {
  font-size: 0.14rem;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 0.20rem;
  color: #FFFFFF;
  opacity: 0.8;
}

.footer-ba {
  font-size: 0.14rem;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 0.2rem;
  color: #FFFFFF;
  opacity: 0.8;
  margin-top: 0.68rem;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue